// extracted by mini-css-extract-plugin
module.exports = {"container":"ContractSwitchBenefits_container__hA6Uv","title":"ContractSwitchBenefits_title__MQhRx"};